// Global styles first: component CSS (imported by the routes) must win over the base.
import '../../../design/tokens/tokens.css';
import './styles/fonts.css';
import './styles/base.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getLocale } from './paraglide/runtime.js';
import { routeTree } from './routeTree.gen.ts';
import { watchKeyboard } from './lib/keyboard.ts';
import { applyTheme, getTheme } from './lib/theme.ts';

document.documentElement.lang = getLocale();
applyTheme(getTheme());
watchKeyboard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true },
  },
});

const router = createRouter({ routeTree, context: { queryClient }, scrollRestoration: true });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
